import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/z.png'
import _imports_1 from '../assets/img/icon_comment.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-97c6ace6")

_pushScopeId("data-v-97c6ace6")
const _hoisted_1 = { class: "topic" }
const _hoisted_2 = { class: "topic-name" }
const _hoisted_3 = { class: "topic-action" }
const _hoisted_4 = { class: "topic-action-item" }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_6 = { class: "topic-action-item" }
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "topic-line" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_swiper_slide = _resolveComponent("swiper-slide")
  const _component_swiper = _resolveComponent("swiper")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_swiper, {
      loop: true,
      autoplay: {
      delay: 3000,
      stopOnLastSlide: false,
      disableOnInteraction: true,
    },
      pagination: { "clickable": true }
    }, {
      default: _withId(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data.slice(0,3), (item) => {
          return (_openBlock(), _createBlock(_component_swiper_slide, {
            key: item.dynamic_id
          }, {
            default: _withId(() => [
              _createVNode("a", {
                href: _ctx.dynamicLink(item.dynamic_id),
                class: "topic-item"
              }, [
                _createVNode("div", _hoisted_2, [
                  _createVNode("img", {
                    src: item.avatar,
                    alt: ""
                  }, null, 8, ["src"]),
                  _createTextVNode(" " + _toDisplayString(item.nick_name), 1)
                ]),
                _createVNode("p", null, _toDisplayString(item.content), 1),
                _createVNode("div", _hoisted_3, [
                  _createVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createVNode("span", null, _toDisplayString(item.like_num || 0), 1)
                  ]),
                  _createVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createVNode("span", null, _toDisplayString(item.comment_num || 0), 1)
                  ])
                ]),
                _hoisted_8
              ], 8, ["href"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    })
  ]))
})